import { HTMLCustomElement } from '@theme/html-custom-element';

class LocalizationForm extends HTMLCustomElement {
  requiredAttributes = ['section-id'];

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.form = this.querySelector('form');

    /**
     * The submit button is only needed when JavaScript is unavailable, so hide
     * it once the selects apply their selection on change.
     */
    const submit = this.form?.querySelector('[type="submit"], button:not([type])');
    if (submit) submit.hidden = true;

    this.on('change', this.refs.country, this.handleChange.bind(this));
    this.on('change', this.refs.language, this.handleChange.bind(this));
  }

  /**
   * Applies the selected country/language immediately by submitting the form.
   */
  handleChange() {
    this.form?.submit();
  }
}

if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
